module.exports = __webpack_public_path__ + "img/ic_referralprogramgbp.b9845e2d.svg";